"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JPosScrollDirection = void 0;
/**
 * The direction of the linear scoll.
 */
class JPosScrollDirection {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        const item = JPosScrollDirection._values.find((it) => it._id === id);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid JPosScrollDirection id: ${id}`);
        }
    }
    static fromRaw(raw, strict = true) {
        const parsedValue = parseInt(raw, 10);
        return JPosScrollDirection.fromId(parsedValue, strict);
    }
    toString() {
        return this._id;
    }
}
exports.JPosScrollDirection = JPosScrollDirection;
// Scroll from left. Represented by `0`.
JPosScrollDirection.Left = new JPosScrollDirection(0);
// Scroll from right. Represented by `1`.
JPosScrollDirection.Right = new JPosScrollDirection(1);
JPosScrollDirection._values = [
    JPosScrollDirection.Left,
    JPosScrollDirection.Right,
];
